import { defineStore } from 'pinia';

type StoreStateType = {
	payment?: string;
};
export const usePaymentStore = defineStore('payment', {
	state: (): StoreStateType => {
		return {
			payment: '',
		};
	},
	getters: {
		getPayment(state) {
			return state.payment;
		},
	},
	actions: {
		setPayment(payment: string) {
			this.payment = payment;
		},
		resetPayment() {
			this.$reset();
		},
	},
	persist: true,
});
